<template>
    <div class="alyssa-goldwater">
        <Header />
        <router-view :key="$route.fullPath" />
    </div>
</template>


<script>
    
    import settings from '@/settings'
    import Header from '@/components/fivetowncentral/Header'

    export default {
        name: 'alyssagoldwater',
        data() {
            return {
                headerComponent: 'AlyssaGoldwaterHeader'
            };
        },
        components: {
            Header
        },
        computed: {
            settings: function () { return settings; },
        },
        methods: {

        }
    }
</script>